<template>
    <div>
        <base-modal :id="String(_uid)" :centered="true" :loading="loading">
            <template slot="title">
                <span class="align-middle">Add to Library</span>
            </template>
            <template>
                <div v-if="hasAuthorMemberships" class="my-2">
                    <p>Select a workspace to add this scenario to:</p>
                    <v-select
                        v-model="selectedMembership"
                        :options="authorMemberships"
                        :close-on-select="true"
                        :getOptionLabel="(option) => option.organization.name"
                        class="mw-100"
                        placeholder="Select a workspace..."
                    >
                        <template slot="option" slot-scope="option">
                            <span class="medium align-middle mr-2">{{ option.organization.name }}</span>
                            <span class="align-middle badge badge-tiny badge-gray">{{
                                displayRoleName(option.role)
                            }}</span>
                        </template>
                        <template v-slot:selected-option="option">
                            <span class="medium align-middle mr-2">{{ option.organization.name }}</span>
                            <span class="align-middle badge badge-tiny badge-gray">{{
                                displayRoleName(option.role)
                            }}</span>
                        </template>
                        <template slot="no-options">
                            <div class="py-2">
                                <span class="text-secondary">You don't have access to any workspaces.</span>
                            </div>
                        </template>
                    </v-select>
                </div>
                <div v-else class="px-2">
                    <div class="d-flex justify-content-center mb-4">
                        <img src="/static/general/img/undraw_box.svg" height="150" alt="" />
                    </div>
                    <p class="text-center mb-4 pt-2 pb-1">
                        Create a workspace for your organization to start using Community scenarios with your students.
                    </p>
                    <div class="d-flex justify-content-center mb-3">
                        <a class="btn btn-brand mr-1" target="_blank" href="/organizations/get-started">Get Started</a>
                        <a class="btn btn-link" target="_blank" href="/login/">Sign In</a>
                    </div>
                </div>
            </template>
            <template slot="footer" v-if="hasAuthorMemberships">
                <button class="btn btn-gray" type="button" data-dismiss="modal">Close</button>
                <button class="btn btn-brand" type="button" :disabled="submitDisabled" @click="submit()">
                    <span class="icon icon-glyphicons-basic-plus icon-mr align-middle"></span>
                    <span class="align-middle">Add</span>
                </button>
            </template>
        </base-modal>
    </div>
</template>
    
<script>
import http from "@/axios.js"
import BaseModal from "@/components/BaseModal"
import { roleNames } from "@/assets/js/settings.js"

export default {
    name: "CommunityAddModal",
    components: {
        BaseModal,
    },
    props: {
        caseObj: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            selectedMembership: null,
            loading: false,
        }
    },
    computed: {
        hasOrgMemberships() {
            return this.$store.getters.memberships.length > 0
        },
        authorMemberships() {
            return this.$store.getters.memberships.filter((membership) => {
                return ["admin", "author"].includes(membership.role)
            })
        },
        hasAuthorMemberships() {
            return this.authorMemberships.length > 0
        },
        submitDisabled() {
            return this.loading || !this.selectedMembership
        },
        activeMembership() {
            return this.$store.getters.activeMembership
        },
    },
    methods: {
        open() {
            $("#" + this._uid).modal("show")
            if (this.activeMembership) {
                this.selectedMembership = this.activeMembership
            }
        },
        displayRoleName(roleCode) {
            let roleName = roleNames[roleCode]
            if (!roleName) {
                // Fallback to the role code.
                return roleCode
            }
            return roleName
        },
        submit() {
            this.loading = true
            let organization = this.selectedMembership.organization
            let vm = this
            http.post(`/api/library-items/`, {
                organizationId: organization.id,
                caseId: this.caseObj.id,
                parent_item_id: this.$route.query.addToParent,
                item_type: "community_reference",
            })
                .then(function () {
                    vm.$notify({
                        group: "main",
                        type: "success",
                        text: "Scenario added to library.",
                        data: {},
                    })
                    vm.$emit("added-to-library", organization)
                    $("#" + vm._uid).modal("hide")
                })
                .finally(() => {
                    vm.loading = false
                })
        },
    },
}
</script>
